import React from 'react';
import { MoonshotBox } from './MoonshotBox';
import { MoonshotSteps } from 'app/common/data/campaigns';
import { MoonshotSubmitFunction } from './types';
import styles from './MoonshotPlanSelection.less';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { UpgradePromptPlanSelection } from 'app/src/components/UpgradePrompts/UpgradePromptPlanSelection';

interface MoonshotPlanSelectionProps {
  onSubmit: MoonshotSubmitFunction;
}

export const MoonshotPlanSelection: React.FC<MoonshotPlanSelectionProps> = ({
  onSubmit,
}) => {
  const onContinueWithTracking = () => {
    onSubmit(MoonshotSteps.PAYMENT_FORM);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SUBMITS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });
  };

  const onSkipWithTracking = () => {
    onSubmit(MoonshotSteps.SUCCESS);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SKIPS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });
  };

  return (
    <MoonshotBox className={styles.upperBox}>
      <UpgradePromptPlanSelection
        onContinue={onContinueWithTracking}
        onSkip={onSkipWithTracking}
        showPlanButtons
      />
    </MoonshotBox>
  );
};
